/**
 * Pure helpers for DrivePickerModal — extracted for unit testing.
 *
 * No React, no network: these functions map the internal selection state to
 * the onConfirm payload and are testable with plain Node.
 */

/**
 * Build the onConfirm items array directly from the selectedFiles map.
 *
 * The map stores the full normalized file node object under each selected id
 * (since DrivePickerModal v2), guaranteeing the confirmed document_uuid and
 * name always match the exact row the user clicked — no secondary tree lookup
 * that could return a different node.
 *
 * Entries that are not a node object (e.g. a boolean `true` value left by an
 * older code path) are skipped so the function degrades gracefully.
 *
 * @param {Record<string, object|boolean>} selectedFiles
 *   Map from document id to the selected tree node (or legacy `true`).
 * @returns {Array<{ document_uuid: string, name: string, file_uuid?: string, file_id?: string }>}
 */
export const buildConfirmItems = (selectedFiles) =>
  Object.values(selectedFiles)
    .filter((node) => node && typeof node === 'object')
    .map((doc) => ({
      document_uuid: doc.document_uuid || doc.id,
      name: doc.name,
      ...(doc.file_uuid ? { file_uuid: doc.file_uuid } : {}),
      ...(doc.file_id ? { file_id: doc.file_id } : {}),
    }));
